import { useState, useEffect } from 'react';

function useURLState<T>(
    key: string,
    initialValue: T,
    searchParams: URLSearchParams,
    takeInitial?: boolean,
    options?: {
        encode?: (value: T) => string | undefined;
        decode?: (value: string) => T;
    }
): [T, React.Dispatch<React.SetStateAction<T>>, URLSearchParams] {
    //Get the initial value from the URL if it exists
    const urlValue = searchParams.get(key);
    const initial = takeInitial
        ? initialValue
        : urlValue && options?.decode
        ? options.decode(urlValue)
        : initialValue;

    //Initialize the state using the initial value
    const [state, setState] = useState<T>(initial);

    //Update the URL whenever the state changes
    useEffect(() => {
        const newValue = state;
        const encodedValue = options?.encode ? options.encode(newValue) : `${newValue}`;
        if (encodedValue !== undefined) {
            searchParams.set(key, encodedValue);
        } else {
            searchParams.delete(key);
        }
    }, [key, searchParams, state, options]);

    return [state, setState, searchParams];
}

export default useURLState;
